<template>
    <form>

        <div class="item_image">
            <img :src="imagePath" alt="item image" />

            <FileUpload
                class="item_image_button"
                :chooseLabel="$t('Item image')"
                mode="basic"
                name="image"
                accept="image/*"
                :maxFileSize="10485760"
                :customUpload="true"
                @uploader="onClickImageUpoad"
                />
        </div>


        <div class="input_item">
            <div class="p-float-label">
                <InputText id="name" type="text" v-model="formData.name"/>
                <label for="name">{{ $t('Item name') }}</label>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('Keep the item names as simple as possible.') }}
            </p>
        </div>

        <div class="input_item">
            <div>
                <TreeSelect
                v-model="formData.category"
                :options="categories"
                :placeholder="$t('Select category')"
                :key="id" :label="name"></TreeSelect>
            </div>
        </div>

        <div class="input_item">
            <div class="p-float-label">
                <AutoComplete  :placeholder="$t('Select maker')" :suggestions="filterMakers" @complete="searchMaker($event)" :dropdown="true" field="name" v-model="formData.maker" force-selection >
                <template #item="slotProps">
                    <div>
                        <div class="ml-2">{{slotProps.item.name}}</div>
                    </div>
                </template>
                </AutoComplete>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('You can also enter and search.') }}
            </p>
        </div>

        <Button
            type="button"
            :label="$t('Update')"
            class="p-button-outlined submit"
            @click="onClickUpdateItem"
            />
    </form>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import TreeSelect from 'primevue/treeselect';
import AutoComplete from 'primevue/autocomplete';
import axios from "axios";
import Message from 'primevue/message';
import Chips from 'primevue/chips';
import { useToast } from "primevue/usetoast";
import { errorToast } from './../../itemListError.js';
import FileUpload from 'primevue/fileupload';

export default {
    components: {
        Button,
        InputText,
        TreeSelect,
        AutoComplete,
        Message,
        Chips,
        FileUpload,
    },
    setup(props) {
        const toast = useToast();

        const formData = reactive({
            name: "",
            category: "",
            maker: "",
        })
        const currentCategories = reactive([]);
        const categories = ref();
        const makers = ref();
        const filterMakers = ref();
        const itemId = ref(0);

        const url = ref();
        const imagePath = ref();


        const searchMaker = (event) => {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    filterMakers.value = [...makers.value];
                }
                else {
                    filterMakers.value = makers.value.filter((country) => {
                        return country.name.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
        };

        const load = () => {
            makers.value = JSON.parse(document.getElementById("json-data-makers").textContent)
            categories.value = JSON.parse(document.getElementById("json-data-item-categories").textContent)
            const item = JSON.parse(document.getElementById("json-data-item").textContent)
            formData.name = item.name
            formData.category = {[item.item_category_id]:true}
            if(item.maker) {
                formData.maker = {
                    code: item.maker.code,
                    name: item.maker.name,
                }
            }
            itemId.value = item.id;
            imagePath.value = item.image_path;
        }
        onMounted(load);

        const onClickUpdateItem = function() {
            const postData = {
                name: formData.name,
                item_category_id:Object.keys(formData.category)[0],
                maker_id:formData.maker ? formData.maker.code : null,
                url:formData.url,
            }
            axios.post(
                '/api/items/' + itemId.value,
                postData,
            ).then(res => {
                location.href = '/items/' + String(itemId.value);
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }

        const onClickImageUpoad = function(event) {
            console.log(event)
            const postData = new FormData()
            postData.append('file', event.files[0])

            axios.post(
                '/api/items/' + itemId.value + '/image_upload',
                postData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            ).then(res => {
                toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
                imagePath.value = res.data.data.image_path;
                console.log(res)
            }).catch(error => {
                errorToast(error.response.data, toast);

            })


        }

        return {
            formData,
            categories,
            makers,
            filterMakers,
            searchMaker,
            onClickUpdateItem,
            onClickImageUpoad,
            imagePath,
        }
    },
}
</script>

<style lang="scss">
.p-chips .p-chips-multiple-container .p-chips-token {
    margin-top: 4px;
}
</style>
